function throwBadNavAction(p) {
    throw new Error('Unknown action kind: ' + p.type);
}
function navReducer(state, action) {
    const getDestinationIndex = (destination) => state.steps.findIndex((s) => s === destination);
    switch (action.type) {
        case 'goToNextStep':
            return {
                ...state,
                index: state.index + 1,
                history: [...state.history, state.steps[state.index]]
            };
        case 'goToPreviousStep': {
            const copyOfNavHistory = state.history;
            const previous = copyOfNavHistory.pop();
            const targetIndex = state.steps.findIndex((stp) => stp === previous);
            return {
                ...state,
                index: targetIndex,
                history: copyOfNavHistory
            };
        }
        case 'navTo':
            return {
                ...state,
                index: getDestinationIndex(action.destination),
                history: [...state.history, state.steps[state.index]]
            };
        case 'reset':
            return {
                steps: action.defaultSteps,
                index: 0,
                history: []
            };
        case 'updateStepsAndGoToNext':
            return {
                index: state.index + 1,
                steps: action.newSteps,
                history: [...state.history, state.steps[state.index]]
            };
        case 'updateStepsAndGoBack': {
            const copyOfNavHistory = state.history;
            const previous = copyOfNavHistory.pop();
            const targetIndex = action.newSteps.findIndex((stp) => stp === previous);
            return {
                index: targetIndex,
                steps: action.newSteps,
                history: copyOfNavHistory
            };
        }
        case 'resetStepsAndNavTo':
            return {
                index: getDestinationIndex(action.destination),
                steps: action.defaultSteps,
                history: [...state.history, state.steps[state.index]]
            };
        case 'resetHistoryAndNavTo':
            return {
                index: getDestinationIndex(action.destination),
                steps: action.defaultSteps,
                history: []
            };
        default:
            // force switch to be complete
            throwBadNavAction(action);
    }
}
export default navReducer;
